export const ROUTES = {
  HOME: "/home",
  HOME_PROCESS_RUNS: "/home/process-runs",
  HOME_PROCESS_RUNS_DETAIL: (id: string) =>
    `/home/process-runs/${encodeURIComponent(id)}`,
  PROCESS_RUN_REVIEW: (id: string) =>
    `/process-runs/${encodeURIComponent(id)}/review`,
} as const;
